export default __webpack_public_path__ + "static/media/arrow-up-solid.ef7f22c6.svg";